import { render } from "./UploadImageModal.vue?vue&type=template&id=40076969&ts=true"
import script from "./UploadImageModal.vue?vue&type=script&lang=ts"
export * from "./UploadImageModal.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3652867025/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__